import React, { useState } from "react";
import Layout from "../layout/Layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { BiEditAlt, BiSolidCheckSquare, BiSolidXSquare } from "react-icons/bi";

const initialData = [
  {
    id: 1,
    name: "Task 1",
    status: "complete",
    deadline: "2023-10-05",
    assignedDate: "2023-09-25",
    role: "Developer",
  },
  {
    id: 2,
    name: "Task 2",
    status: "incomplete",
    deadline: "2023-10-10",
    assignedDate: "2023-09-26",
    role: "Designer",
  },
  {
    id: 3,
    name: "Task 3",
    status: "completeD",
    deadline: "2023-10-10",
    assignedDate: "2023-09-26",
    role: "Developer",
  },
  {
    id: 4,
    name: "Task 4",
    status: "incomplete",
    deadline: "2023-10-10",
    assignedDate: "2023-09-26",
    role: "Designer",
  },
  {
    id: 5,
    name: "Task 5",
    status: "completeD",
    deadline: "2023-10-10",
    assignedDate: "2023-09-26",
    role: "DeveloperS",
  },
];

const Setting = () => {
  const [status, setStatus] = useState("Incomplete");

  const handleUpload = (itemId) => {
    setStatus("Complete");
  };

  const navigate = useNavigate();
  const handleButtonClick = () => {
    // Define the URL you want to open in a new tab
    const urlToOpen = "/todolist"; // Replace with your desired URL

    // Open a new tab with the specified URL
    window.open(urlToOpen, "_blank");
  };

  const text =
    "change the mouse cursor to indicate something that can be moved.";
  const words = text.split(" ");

  const [filter, setFilter] = useState("");
  const [data, setData] = useState(initialData);

  const handleFilterChange = (event) => {
    const filterValue = event.target.value.toLowerCase();
    setFilter(filterValue);

    const filteredData = initialData.filter(
      (item) =>
        item.status.toLowerCase().includes(filterValue) ||
        item.role.toLowerCase().includes(filterValue)
    );
    setData(filteredData);
  };

  return (
    <Layout>
      <div className="conatiner">
        <div className="grid grid-cols-10 gap-5 m-10 mt-28">
          <div className=" bg-white p-5 font-sans col-span-3 rounded-[30px] ">
            <p className="text-[#22345C] font-semibold lg:text-[30px] text-[20px]">
              Settings
            </p>
            <p className="mt-5 text-xl hover:bg-[#E4E6EB] p-3 font-semibold rounded-lg mr-32">
              Document
            </p>
            <p className="mt-5 text-xl hover:bg-[#E4E6EB] bg-[#E4E6EB] p-3 font-semibold rounded-lg mr-32">
              Personal Information
            </p>
            <p className="mt-5 text-xl hover:bg-[#E4E6EB] p-3 font-semibold rounded-lg mr-32">
              Security
            </p>
            <p className="mt-5 text-xl hover:bg-[#E4E6EB] p-3 font-semibold rounded-lg mr-32">
              Billing Information
            </p>
            <p className="mt-5 text-xl hover:bg-[#E4E6EB] p-3 font-semibold rounded-lg mr-32">
              Message
            </p>
            <p className="mt-5 text-xl hover:bg-[#E4E6EB] p-3 font-semibold rounded-lg mr-32">
              Data export
            </p>
          </div>
          <div className=" bg-white p-5 font-sans col-span-6 rounded-[30px] ">
            <p className="text-[#22345C] font-semibold lg:text-[30px] text-[20px]">
              Personal Information
            </p>
            <p className="mt-5 font-semibold text-[22px]">Profile</p>
            <p className="mb-5 font-normal text-[#828282] text-[18px]">
              This information will be display publicly so be careful what your
              share.
            </p>
            <div className="grid grid-cols-2 gap-5  mb-24">
              <div>
                <label className="block text-[18px] font-medium">
                  First name
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none h-[40px] rounded-lg px-3"
                />
              </div>
              <div>
                <label className="block text-[18px] font-medium">
                  Last name
                </label>
                <input
                  type="text"
                  className="w-full border outline-none h-[40px] rounded-lg px-3"
                />
              </div>
              <div>
                <label className="block text-[18px] font-medium">Email</label>
                <input
                  type="text"
                  className="w-full border outline-none h-[40px] rounded-lg px-3"
                />
              </div>
              <div className="col-span-full">
                <label className="block text-[18px] font-medium">About</label>
                <textarea
                  type="text"
                  rows="5"
                  className="w-full resize-none border outline-none  rounded-lg p-2.5"
                />
              </div>
            </div>
          </div>
        </div>

        {/* <div>
          Your other content
          <button
            onClick={handleButtonClick}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Open in New Tab
          </button>
        </div> */}

        {/* <div className="text-center">
          <p className="text-2xl font-bold">{words?.slice(0, 2).join(" ")}</p>
          <p className="mt-2 text-lg">{words?.slice(2).join(" ")}</p>
        </div> */}

        {/* <div className="p-4">
          <div className="mb-4">
            <label htmlFor="statusFilter" className="block font-bold mb-2">
              Filter by Status:
            </label>
            <input
              type="text"
              id="statusFilter"
              className="border rounded-md p-1 w-full"
              value={filter}
              onChange={handleFilterChange}
            />
          </div>

          <table className="w-full">
            <thead>
              <tr>
                <th className="border p-2">Name</th>
                <th className="border p-2">Status</th>
                <th className="border p-2">Deadline</th>
                <th className="border p-2">Assigned Date</th>
                <th className="border p-2">Role</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <>
                  <tr key={item.id}>
                    <td className="border p-2">{item.name}</td>
                    <td className="border p-2">{item.status}</td>
                    <td className="border p-2">{item.deadline}</td>
                    <td className="border p-2">{item.assignedDate}</td>
                    <td className="border p-2">{item.role}</td>
                    <td className="p-3">
                      <div className="flex gap-1 items-center">
                        {status === "Incomplete" ? "Incomplete" : "Complete"}
                        <span>
                          {status === "Incomplete" && (
                            <BiSolidXSquare
                              size={25}
                              className="text-[#FF270E]"
                            />
                          )}
                        </span>
                      </div>
                    </td>
                    <td className="p-3">
                      <div className="flex gap-1 items-center">
                        {status === "Incomplete" ? (
                          <div
                            onClick={() => handleUpload(item._id)}
                            className="cursor-pointer text-[#FFFFFF] bg-[#5DC90A] rounded-[10px] py-2 px-4"
                          >
                            Upload
                          </div>
                        ) : (
                          <span className="text-green-500">Uploaded</span>
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr></tr>
                </>
              ))}
            </tbody>
          </table>
        </div> */}
      </div>
    </Layout>
  );
};

export default Setting;
